import { render, staticRenderFns } from "./ModalEsqueceuSenha.vue?vue&type=template&id=dace638e&"
import script from "./ModalEsqueceuSenha.vue?vue&type=script&lang=js&"
export * from "./ModalEsqueceuSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports